import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/content";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 sm:py-24" aria-label="Frequently asked questions" data-id="element-148" data-mp="urkoi91u8h5h">
      <div className="mx-auto max-w-3xl" data-id="element-149" data-mp="71gn88c4gthn">
        <SectionHeading eyebrow="Frequently asked questions" title="Your Questions, Answered" data-id="element-150" data-mp="22dkiujm6zcu" />

        <ul className="mt-10 space-y-3" data-id="element-151" data-mp="gz4mnbkoap65">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-152" data-mp="bzi9110xn6wt" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-153" data-mp="1sdi6848e8igd">
                  <span className="text-base sm:text-lg font-bold text-ink" data-id="element-154" data-mp="rrnc8yxe5db2">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-155" data-mp="vu0hlm88797b" />
                </button>
                <AnimatePresence initial={false} data-id="element-156" data-mp="42uaglu38b8j">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-157" data-mp="834h80ppf5og">
                      <p className="px-5 pb-5 text-base leading-relaxed text-ink/75" data-id="element-158" data-mp="np96av4p6e2s">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-159" data-mp="xfbxqqw67jz0">
          <CtaButton label="I'm ready — give me instant access" data-id="element-160" data-mp="xe978k2rfjjm" />
        </div>
      </div>
    </section>;
}